export const DREAM_SEO_DEDICATED_SLUGS = new Set([
  "sonar-que-se-caen-los-dientes",
  "sonar-con-serpientes",
  "sonar-con-aranas",
  "sonar-con-ratas",
]);

export const DREAM_SEO_REDIRECTS: Record<string, string> = {
  "sonar-con-tu-ex": "/que-significa-sonar-con/personas/ex-pareja",
  "sonar-con-familiares-fallecidos":
    "/que-significa-sonar-con/personas/familiar-fallecido",
  "sonar-con-muertos": "/que-significa-sonar-con/personas/alguien-fallecido",
  "sonar-con-personas-fallecidas":
    "/que-significa-sonar-con/personas/familiar-fallecido",
};

export const CONTENT_SUENO_REDIRECTS: Record<string, string> = {
  "animales/aranas": "/significado-de-los-suenos/sonar-con-aranas",
  "situaciones/dientes-que-se-caen":
    "/significado-de-los-suenos/sonar-que-se-caen-los-dientes",
  "animales/serpientes": "/significado-de-los-suenos/sonar-con-serpientes",
  "animales/ratas": "/significado-de-los-suenos/sonar-con-ratas",
};

export const isDreamSeoSsable = (slug: string) =>
  !DREAM_SEO_DEDICATED_SLUGS.has(slug) && !(slug in DREAM_SEO_REDIRECTS);

export const isContentSuenoSsable = (categoria: string, slug: string) =>
  !(`${categoria}/${slug}` in CONTENT_SUENO_REDIRECTS);
